import '../../App.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FaPlus } from 'react-icons/fa';
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Toolbar, Sort } from '@syncfusion/ej2-react-grids';
import { L10n } from '@syncfusion/ej2-base';
import ModalCadastrarSwotServico from '../../components/modal/ModalCadastrarSwotServico';
import ModalEditarSwotServico from '../../components/modal/ModalEditarSwotServico';
import ModalExcluirSwotServico from '../../components/modal/ModalExcluirSwotServico';
import ModalRelatorioSwotServico from '../../components/modal/ModalRelatorioSwotServico';
import moment from 'moment/moment';
import { TbTrash, TbPencil } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import Tabela from '../../components/Tabela';

const SwotServicoServicos = () => {
    const { ObterSwotServico, setLoading, EditarDemandaModal, setModalEditarDemanda, Success, Error, ExcluirDemandaModal, setModalExcluirDemanda, openModal, setOpenModal, ListaCiclos, loading, CancelarDemandaModal, ConcluirDemandaModal, setCompartilharDemandaModal, CompartilharDemandaModal, ListaSwotServicoConsulta, SwotServicoListaConsulta, setSwotServicoAtualKey, Permissao, ListaAreaSwotServico, ListaFiltroSwotServico, totalRegistrosSwotServico, filtroSwotServico, totalRegistrosFiltroSwotServico } = useContext(ApiContext)
    const { btnCriar, h3Demanda, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const CriarSwotServico = () => {
        setOpenModal(true)
    }

    const selecionarSwotServico = (props) => {
        ObterSwotServico(props.key)
            .then(() => {
                EditarSwotServico(props)
            })
    }

    const EditarSwotServico = (props) => {
        setSwotServicoAtualKey(props.key)
        setModalEditarDemanda(true)
    }

    const ApagarSwotServico = (props) => {
        setSwotServicoAtualKey(props.key)
        setModalExcluirDemanda(true)
    }

    const VerRelatorio = (props) => {
        setSwotServicoAtualKey(props.key)
        setCompartilharDemandaModal(true)
    }

    function carregando() {
        return new Promise(function (resolve) {
            setLoading(true)
            setTimeout(resolve, 1)
        });
    }

    function naoCarregando() {
        return new Promise(function (resolve) {
            setLoading(resolve, false)
        });
    }

    const chamarLista = useCallback(async () => {
        await carregando()
        await ListaSwotServicoConsulta(1, 10)
        await ListaAreaSwotServico()
        await ListaCiclos()
        await naoCarregando()
    })

    useEffect(() => {
        chamarLista()
    }, [])

    useEffect(() => {
        if (openModal || EditarDemandaModal || ExcluirDemandaModal || CancelarDemandaModal || ConcluirDemandaModal || CompartilharDemandaModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [openModal, EditarDemandaModal, ExcluirDemandaModal, CancelarDemandaModal, ConcluirDemandaModal, CompartilharDemandaModal]);

    useEffect(() => {
        setCompartilharDemandaModal(false)
    }, [])

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroSwotServico(searchTerm, currentPage, pageSize);
        } else {
            ListaSwotServicoConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroSwotServico : totalRegistrosSwotServico;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>

            {EditarDemandaModal &&
                <ModalEditarSwotServico currentPage={currentPage} />
            }
            {CompartilharDemandaModal &&
                <ModalRelatorioSwotServico/>
            }
            {ExcluirDemandaModal &&
                <ModalExcluirSwotServico currentPage={currentPage}/>
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <Header pagina={'SWOT de Serviço'}></Header>
            <MenuLateral></MenuLateral>
            <div className="container-dem">
                <div className='header-dem'>
                    {openModal &&
                        <ModalCadastrarSwotServico closeModal={setOpenModal} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "SWOT SERVICO" && item.edicao === true)) && <button className='btn-dash btn-criar' style={btnCriar} onClick={() => CriarSwotServico()}><FaPlus style={{ marginRight: "10px" }} />Cadastrar SWOT</button>
                    }
                </div>
                {loading &&
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                }
                <div className='card'>
                    <h3 className='h3-demanda' style={h3Demanda}>SWOTs de Serviço cadastrados</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroSwotServico : SwotServicoListaConsulta}
                        columns={[
                            { label: "SWOTs", field: "descricao", width: "40%" },
                            { label: "Área", field: "area.descricao", width: "40%", render: (x) => x?.area?.descricao || "-" },
                            { label: "Ciclo", field: "cicloDemanda.descricao", width: "40%", render: (x) => x?.cicloDemanda?.descricao || "-" },
                            { label: "Data criação", field: "dataCriacao", width: "40%", render: (x) => moment(x?.dataCriacao).format("DD/MM/YYYY") || "-" },
                            { label: "Usuário", field: "usuario", width: "40%", render: (x) => x?.usuario?.nome || "-" },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <OverlayTrigger
                                            placement="left"
                                            overlay={<Tooltip id="button-tooltip">
                                                Editar SWOT
                                            </Tooltip>}
                                        ><button className='btn-dem' style={{ color: `${corTerciaria}` }} onClick={() => selecionarSwotServico(x)}><TbPencil /></button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement="left"
                                            overlay={<Tooltip id="button-tooltip">
                                                Ver relatório
                                            </Tooltip>}
                                        ><button className='btn-dem' style={{ color: `${corTerciaria}` }} onClick={() => VerRelatorio(x)}><HiOutlineDocumentReport /></button>

                                        </OverlayTrigger>
                                        {(!!Permissao.find(item => item.menu.descricao === "SWOT" && item.edicao === true)) &&
                                            <OverlayTrigger
                                                placement="left"
                                                overlay={<Tooltip id="button-tooltip">
                                                    Excluir SWOT
                                                </Tooltip>}
                                            ><button className='btn-dem' style={{ color: `${corTerciaria}` }} onClick={() => ApagarSwotServico(x)}><TbTrash /></button>
                                            </OverlayTrigger>
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        loading={loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroSwotServico(term, 1, 10);
                            } else {
                                ListaSwotServicoConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default React.memo(SwotServicoServicos);